import { Component, OnInit } from "@angular/core";
import { DataList } from "@data/schemas/filter/data-list";
import { Filter } from "@data/schemas/filter/filter";
import { ColumnTable } from "@shared/schemas/column-table";
import { HttpParamsConfig } from "@shared/schemas/http-params-config";
import { RowTable } from "@shared/schemas/row-table";
import { BaseCrudService } from "@shared/services/base-crud.service";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Observable } from "rxjs";

@Component({
	selector: "app-search-datatable-modal",
	templateUrl: "./search-datatable-modal.component.html",
	styleUrls: ["./search-datatable-modal.component.scss"],
	standalone: false
})
export class SearchDatatableModalComponent<T extends RowTable>
	implements OnInit
{
	title: string;
	closeBtnName: string;
	list: RowTable[] = [];
	columns: ColumnTable[] = [];
	totalElements = 0;
	filters!: Filter;
	defaultHttpParams: HttpParamsConfig = {
		page: 0,
		size: 5
	};
	endpointSearchModel?: string = "";
	selectedRow?: RowTable;

	constructor(
		public bsModalRef: BsModalRef,
		private baseCrudService: BaseCrudService
	) {
		this.title = "";
		this.closeBtnName = "";
	}

	ngOnInit() {
		this.populateListByHttpParams(this.defaultHttpParams);
	}

	private populateListByHttpParams(httpParams?: HttpParamsConfig): void {
		if (httpParams) {
			httpParams.fields = [
				...(httpParams.fields ?? []),
				...(this.defaultHttpParams.fields ?? [])
			];
		}

		if (this.endpointSearchModel) {
			this.getAllItems(this.endpointSearchModel, httpParams).subscribe(
				(data) => {
					this.list = data.content;
					this.totalElements = data.totalElements;
					this.filters = data.filter;
				}
			);
		}
	}

	private getAllItems(
		urlEndpointSearchModel: string,
		httpParamsConfig?: HttpParamsConfig
	): Observable<DataList<T>> {
		return this.baseCrudService.getAll<DataList<T>>(
			urlEndpointSearchModel,
			httpParamsConfig
		);
	}

	refreshTable(httpParams?: HttpParamsConfig): void {
		this.populateListByHttpParams(httpParams);
	}

	selectRow(row: RowTable): void {
		this.selectedRow = row;
		this.bsModalRef.hide();
	}
}
